import entity from './entity';
import user from './user';
import fraccionesLotes from './fraccionesLotes';

const modules = [
  entity,
  user,
  fraccionesLotes
];
/**
 * Module Structure {
 *    // Set Permissions for data and sections
 *    // Custom component parts
 * 
 *    slug,
 *    label,
 * 
 *    entities: {
 *      [slug]: {
 *        entity: { id, nameSlug, ... },
 *        filterMenuList: [ { id, entityId, nameSlug, filters: [ taxonomyTypeId ] ... },  ...],
 *        taxonomyTypesList: [ { id, entityId, type, nameSlug, ... },  ...],
 *      }
 *    },
 * 
 *    permissions: {
 *      [resourceSlug]: [...actionListSlugs]
 *    },
 * 
 *    routesPublic,
 *    routesAdmin: {
 *      [slug]: {
 *        [action]: {
 *          permission: { resource, action },
 *          Content // param { parsedParams, isAllowed, config, Model, module, action, isMinBreakpointActive, location, navigate }
 *        }
 *      }
 *    },
 * 
 *    compoents: {
 *      main: {
 *        CustomRoutes, // param { Route, ProtectedRoute }
 *        AdminHomeBeforeLinksList // param { isAllowed }
 *        AdminHomeAfterLinksList // param { isAllowed }
 *      },
 * 
 *      [slug]: {
 *    
 *        // Custom DataType for Entity, require 'coded' as the taxonomyType
 *        codedDataTypes: {
 *          [entityTaxonomyType.nameSlug]: { 
 *            RenderForm, // param { value, onChange }
 *            RenderShow // param { displayedValue, doc, field }
 *          }
 *        },
 * 
 *        crud: {
 *          ListHeaderExtraActions, // param { Model, isAllowed }
 *          UnderForm, // param { values }
 *          UnderListItemTitle, // param { doc, ViewData, mainAttr, mainImgAttr, isAllowed, entitySlug }
 *          UnderListItemHeader, // param { doc, ViewData, mainAttr, mainImgAttr, isAllowed, entitySlug }
 *        }
 *        
 *      }
 *    },
 * 
 *   events: {
 *     [slug]: {
 *       beforeSave, 
 *         // param { taxonomyTypesDocList }, formValues
 *         // return formValues
 *     }
 *   }
 * 
 * }
 */

export const boot = () => {
  let actionsByResource = {};

  const modulesBooted = modules.map((moduleBoot) => {
    const definitions = moduleBoot({ setPermissions });
    // map actions by resource for permissions
    definitions?.permissions?.forEach(permissions => {
      actionsByResource[permissions?.resource] = permissions;
    });
    return definitions;
  });
  return {
    modules: modulesBooted,
    actionsByResource
  }
};

export const setPermissions = ({ slug, label, actionsToAdd=[], type, actions }) => {
  return {
    resource: slug,
    label,
    type,
    actions: actions || [
      'read',
      'list',
      'create',
      'update',
      'delete',
      ...actionsToAdd
    ]
  }
}